import React from "react";
import styled, { keyframes } from "styled-components";

const dotAnimation = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1.0); }
`;

const DotsWrapper = styled.span`
  display: inline-block;
`;

const Dot = styled.span`
  width: 6px;
  height: 6px;
  background-color: #333;

  border-radius: 100%;
  display: inline-block;
  animation: ${dotAnimation} 1.4s infinite ease-in-out both;

  &:nth-child(1) {
    animation-delay: -0.32s;
  }

  &:nth-child(2) {
    animation-delay: -0.16s;
  }
`;

const LoadingDots = () => (
  <DotsWrapper>
    <Dot />
    <Dot />
    <Dot />
  </DotsWrapper>
);

export default LoadingDots;
